import React from 'react';
import { User, MapPin, Mail, Phone } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  name: string;
  passportNumber: string;
  gender: 'male' | 'female';
  country: string;
  email?: string;
  mobileNumber?: string; // Added mobileNumber prop
};

export const PilgrimInfo = ({
  name,
  passportNumber,
  gender,
  country,
  email,
  mobileNumber, // Added parameter
}: Props) => {
  const { translations } = useLanguage();

  return (
    <td className="px-6 py-4">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div
            className={`p-2 rounded-full ${
              gender === 'male' ? 'bg-blue-50' : 'bg-pink-50'
            }`}
          >
            <User
              className={gender === 'male' ? 'text-blue-500' : 'text-pink-500'}
              size={20}
            />
          </div>
          <div>
            <div className="font-medium">{name}</div>
            <div className="text-sm text-gray-500">
              {translations?.pilgrimInfo?.passport || 'Passport'}:{' '}
              {passportNumber}
            </div>
            <div className="text-sm text-gray-500 flex items-center gap-1">
              <Mail size={14} className="text-gray-400" />
              <span>{email || '-'}</span>
            </div>
            {/* Added Phone Number */}
            <div className="text-sm text-gray-500 flex items-center gap-1">
              <Phone size={14} className="text-gray-400" />
              <span>{mobileNumber || '-'}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <MapPin size={16} />
          <span>{country}</span>
        </div>
      </div>
    </td>
  );
};